import React, { useEffect, useState } from 'react'
import './Banner.scss'
import Slider from "react-slick";
import { Baseurl } from '../../constants/env';
import axios from 'axios'
import { Link } from 'react-router-dom';

const Banner = () => {


  const [bannerdata, setBannerdata] = useState([])

  const init = async () => {
    let result = await axios.get(`${Baseurl}/banner`)
    
    setBannerdata(result?.data)

  }

  const settings = {
    dots: true,
    infinite: true, // or true, depending on your needs
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
};

  useEffect(() => {
(async () => {
 await init()
})()
  },[])
  return (
    <>

<section className="section-banner">
      <div className="container">
        <Slider {...settings}>
          {bannerdata?.map((item, index) => (
            <div className="banner-box" key={index}> 
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: '7' }}> 
                  <h3>{item?.name}</h3>
                  <h1>{item?.heading}</h1>
                 <Link to={item?.button}> <button type="button" className="btn btn-primary-theme me-3"> 
                    Learn More
                  </button> </Link>
                </div>
                <div style={{ flex: '5' }}>
                  <img
                    src={`${Baseurl}/view/imageupload/${item.img}`}
                    className="img-fluid"
                    alt="banner"
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>

    </>
  )
}

export default Banner
